import parse from 'html-react-parser'
import { type ReactElement, useState } from 'react'
import { accessiblilityMsg, encodedLeftParen, encodedRightParen } from '#app/components/ui/constants'
import { ThreeButtonGroup } from '#app/components/ui/my-buttons/button-groups.tsx'

export type BookFootnotesProps = {
  BookTitle: string;
  V1Title: string;
  V1C1Title: string;
  V1C2Title: string;
  V1C3Title: string;
  V1C4Title: string;
  V2Title: string;
  V2C1Title: string;
  V2C2Title: string;
  V2C3Title: string;
  V2C4Title: string;
  BookRoute: string;
  Vol1Ch1: ReactElement;
  Vol1Ch2: ReactElement;
  Vol1Ch3: ReactElement;
  Vol1Ch4: ReactElement;
  Vol2Ch1: ReactElement;
  Vol2Ch2: ReactElement;
  Vol2Ch3: ReactElement;
  Vol2Ch4: ReactElement;
  AdditionalComments?: ReactElement;
}

const BookFootnotes = (props: BookFootnotesProps) => {
  const [showResults1_1, setShowResults1_1] = useState(false)
  const onClick1_1 = () => {
    showResults1_1 ? setShowResults1_1(false) : setShowResults1_1(true)
  }
  const [showResults1_2, setShowResults1_2] = useState(false)
  const onClick1_2 = () => {
    showResults1_2 ? setShowResults1_2(false) : setShowResults1_2(true)
  }
  const [showResults1_3, setShowResults1_3] = useState(false)
  const onClick1_3 = () => {
    showResults1_3 ? setShowResults1_3(false) : setShowResults1_3(true)
  }
  const [showResults1_4, setShowResults1_4] = useState(false)
  const onClick1_4 = () => {
    showResults1_4 ? setShowResults1_4(false) : setShowResults1_4(true)
  }
  const [showResults2_1, setShowResults2_1] = useState(false)
  const onClick2_1 = () => {
    showResults2_1 ? setShowResults2_1(false) : setShowResults2_1(true)
  }
  const [showResults2_2, setShowResults2_2] = useState(false)
  const onClick2_2 = () => {
    showResults2_2 ? setShowResults2_2(false) : setShowResults2_2(true)
  }
  const [showResults2_3, setShowResults2_3] = useState(false)
  const onClick2_3 = () => {
    showResults2_3 ? setShowResults2_3(false) : setShowResults2_3(true)
  }
  const [showResults2_4, setShowResults2_4] = useState(false)
  const onClick2_4 = () => {
    showResults2_4 ? setShowResults2_4(false) : setShowResults2_4(true)
  }
  const onClickCloseAll = () => {
    setShowResults1_1(false)
    setShowResults1_2(false)
    setShowResults1_3(false)
    setShowResults1_4(false)
    setShowResults2_1(false)
    setShowResults2_2(false)
    setShowResults2_3(false)
    setShowResults2_4(false)
  }

  const ariaLabelTitleSection = `footnotes ${props.BookTitle.toLowerCase()} section`

  return (
		<div className='route-container'>
			<div className='route-content-container'>
				<div 
					className='section justify-center'
					aria-label={ariaLabelTitleSection}
				>
					<h1 className='content-page-title'>
						{`${props.BookTitle} Footnotes`}
					</h1>
					<div className='content-page-content-container pt-6'>
						<div className='content-page-content-container-other'>
							<div className='content-page-content-no-spread'>
                {parse(`I use the format Volume.Chapter.Scene ${encodedLeftParen}e.g., 1.1.1${encodedRightParen} to point to the scene in the book. Included are: the date it takes place; the point of view ${encodedLeftParen}POV${encodedRightParen} character; and any trigger or content warnings ${encodedLeftParen}CW${encodedRightParen}. I encourage readers to check out these places and their environs on a map tool with street views. I also included historical links to explore.`)}
							</div>
              {(!props.AdditionalComments) ? null : (props.AdditionalComments)}
						</div>
            <div className='content-page-content-container-other'>
              {(
                  !showResults1_1 &&
                  !showResults1_2 &&
                  !showResults1_3 &&
                  !showResults1_4 &&
                  !showResults2_1 &&
                  !showResults2_2 &&
                  !showResults2_3 &&
                  !showResults2_4
                ) ? null : (<div className='section'>
                <div className='content-page-content-container-other'>
                  <div>
                    <input
                      type='submit'
                      value='Close All'
                      onClick={onClickCloseAll}
                      className='link content-page-sub-subtitle text-xl md:text-2xl'
                    />
                  </div>
                </div>
              </div>)}
              <div>
                <div className='section' aria-label='volume one section'>
                  <div className='content-page-content-container-other'>
                    <h2  className='content-page-subtitle pb-4'>
                      {props.V1Title}
                    </h2>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter One: ${props.V1C1Title}`}
                        onClick={onClick1_1}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults1_1 ? <div>{props.Vol1Ch1}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Two: ${props.V1C2Title}`}
                        onClick={onClick1_2}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults1_2 ? <div>{props.Vol1Ch2}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Three: ${props.V1C3Title}`}
                        onClick={onClick1_3}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults1_3 ? <div>{props.Vol1Ch3}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Four: ${props.V1C4Title}`}
                        onClick={onClick1_4}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults1_4 ? <div>{props.Vol1Ch4}</div> : null }
                    </div>
                  </div>
                </div>
                <div className='section' aria-label='volume two section'>
                  <div className='content-page-content-container-other'>
                    <h2  className='content-page-subtitle pb-4'>
                      {props.V2Title}
                    </h2>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter One: ${props.V2C1Title}`}
                        onClick={onClick2_1}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults2_1 ? <div>{props.Vol2Ch1}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Two: ${props.V2C2Title}`}
                        onClick={onClick2_2}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults2_2 ? <div>{props.Vol2Ch2}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Three: ${props.V2C3Title}`}
                        onClick={onClick2_3}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults2_3 ? <div>{props.Vol2Ch3}</div> : null }
                    </div>
                  </div>
                  <div className='content-page-content-container-other'>
                    <div>
                      <input
                        type='submit'
                        value={`Chapter Four: ${props.V2C4Title}`}
                        onClick={onClick2_4}
                        className='link content-page-sub-subtitle text-xl md:text-2xl'
                      />
                      { showResults2_4 ? <div>{props.Vol2Ch4}</div> : null }
                    </div>
                  </div>
                </div>
              </div>
            </div>
					</div>
				</div>
        <div className='container pt-8 sm:pt-4 md:pt-10'>
          <div className='text-sm md:text-md pb-2'>
            Apologies for any links that no longer work. The net is a fickle mistress. Likely, some have changed, and some have been removed. Let me know if you find anything you'd like to know more about.
          </div>
          <div className='text-sm md:text-md'>
            Many thanks to the following sources which provided a wealth of information to keep my accounting of these stories as accurate as possilble.
          </div>
          <div className='text-sm md:text-md'>
            <a
              href='https://whatthefuckjusthappenedtoday.com/'
              aria-label='link to WTFJHT.com'
              className='link px-0 py-0 text-sm md:text-md'
            >What the Fuck Just Happened Today</a> for copious notes on political events. <a
                href='https://whatthefuckjusthappenedtoday.com/membership/'
                aria-label='link to WTFJHT membership and donations'
                className='link px-0 py-0 text-sm md:text-md'
              >Donations are accepted here.</a>
          </div>
          <div className='text-sm md:text-md'>
            <a
              href='https://en.wikipedia.org/wiki/Main_Page'
              aria-label='link to Wikipedia'
              className='link px-0 py-0 text-sm md:text-md'
            >Wikipedia</a> and its contributors for numerous citations. <a
              href='https://wikimediafoundation.org/support/'
              aria-label='link to Wikipedia donations'
              className='link px-0 py-0 text-sm md:text-md'
            >You can donate to them here.</a>
          </div>
        </div>
        {ThreeButtonGroup ({label: 'Go to Book', route: props.BookRoute})}
        <div className='container'>
          {accessiblilityMsg}
        </div>
			</div>
		</div>
  )
}

export default BookFootnotes